
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type singleVehicleGarageRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function singleVehicleGarageRT(): TemplateResult<singleVehicleGarageRTRootProps> {
    return _createElement('div', { 'className': 'nav-action' }, _createElement('a', { 'className': 'cm_single-vehicle-garage' }, [this.changeButton(function () {
            return _createElement('div', {
                'aria-label': 'button',
                'className': 'cm_changeButton'
            }, _createElement('div', { 'className': 'garage-icon cm_icon_garage__background icon' }), ' \n      ', this.template === 'active' ? _createElement('div', {
                'className': 'cmTemplate_active',
                'key': '131'
            }, window.Convermax.config?.selectYourVehicleTitle || _translate(`ymm_bar_title`)) : null, this.template === 'locked' ? _createElement('div', {
                'className': 'cmTemplate_locked',
                'key': '301'
            }, this.vehicleString) : null);
        }, {
            widgetName: 'undefined',
            items: undefined
        })], this.template === 'locked' ? _createElement('div', {
        'onClick': this.goToResults,
        'className': 'go-to-results cmTemplate_locked',
        'key': '910'
    }, _createElement('span', {}, '>')) : null, this.template === 'locked' ? _createElement('div', {
        'onClick': this.discardVehicle,
        'className': 'clear-garage cmTemplate_locked',
        'key': '1069'
    }, _createElement('span', {}, [_createElement('svg', {
            'xmlns': 'http://www.w3.org/2000/svg',
            'className': 'cm_icon cm_icon-reset',
            'height': '16px',
            'viewBox': '0 0 16 16',
            'key': '12030'
        }, _createElement('path', { 'd': 'M2.083,9H0.062H0v5l1.481-1.361C2.932,14.673,5.311,16,8,16c4.08,0,7.446-3.054,7.938-7h-2.021 c-0.476,2.838-2.944,5-5.917,5c-2.106,0-3.96-1.086-5.03-2.729L5.441,9H2.083z' }), _createElement('path', { 'd': 'M8,0C3.92,0,0.554,3.054,0.062,7h2.021C2.559,4.162,5.027,2,8,2c2.169,0,4.07,1.151,5.124,2.876 L11,7h2h0.917h2.021H16V2l-1.432,1.432C13.123,1.357,10.72,0,8,0z' }))])) : null));
}
        export const componentNames = ["cm:changeButton"]